import freeTextBlock from "@areas/Core/Views/Blocks/FreeTextBlock/xyl.views.freeTextBlock";
import { marketoForm } from "@areas/LeadGeneration/Views/Blocks/MarketoFormBlock/js/xyl.views.marketoForm";
import findALocationBlock from "@areas/Location/Views/Blocks/FindALocationBlock/xyl.views.findALocationBlock";
import findNearestLocationBlock from "@areas/Location/Views/Blocks/NearestLocationBlock/xyl.views.NearestLocationBlock";
import mostRecentBlock from "@areas/NewsEvents/Views/Blocks/MostRecentBlock/xyl.views.mostRecentBlock";
import redirectPopupBlock from "@areas/Core/Views/Blocks/RedirectPopupBlock/redirectPopupBlock";
import genericCardBlock from "@areas/Core/Views/Blocks/GenericCardBlock/xyl.views.genericCardBlock";
import documentSearchBlock from "@areas/Search/Views/Blocks/DocumentSearchBlock/xyl.views.documentSearchBlock";
import shipmentTrackingSearchBlock from "@areas/Search/Views/Blocks/ShipmentTrackingSearchBlock/xyl.views.shipmentTrackingSearchBlock";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const blocks: XylView[] = [
	freeTextBlock,
	marketoForm,
	findALocationBlock,
	findNearestLocationBlock,
	mostRecentBlock,
	genericCardBlock,
	documentSearchBlock,
	redirectPopupBlock,
	shipmentTrackingSearchBlock,
];
